"use client";

import React, { type JSX } from "react";
import { useAuth, useUser } from "@clerk/nextjs";

import { Show } from "@clerk/nextjs";

import Link from "next/link";
import { Building, User } from "iconoir-react";
import classNames from "classnames";
import { useSignInRedirect } from "@/auth/hooks/useSignInRedirect";

export default function MyPageButton({
  className,
  style,
  showIcon = true,
  showText = true,
}: Pick<JSX.IntrinsicElements["button"], "className" | "style"> & {
  showIcon?: boolean;
  showText?: boolean;
}) {
  const { isLoaded } = useUser();
  const { orgId } = useAuth();
  const signInAction = useSignInRedirect();

  if (!isLoaded) {
    return <span className="max-h-7 text-sm font-light">Laster...</span>;
  }

  return (
    <>
      <Show when="signed-out">
        <button
          onClick={signInAction}
          className={classNames(
            "cursor-pointer items-center gap-1",
            "cvr-button min-h-0 min-w-0 !px-4 !py-2",
            className,
          )}
          style={style}
          {...(!showText && { "aria-label": "Logg inn" })}
        >
          {showIcon ? <User className="inline" width={28} height={28} /> : null}
          {showText ? <span className="text-base">Logg inn</span> : null}
        </button>
      </Show>
      <Show when="signed-in">
        <Link href="/min-side">
          <button
            className={classNames(
              "cursor-pointer items-center gap-1",
              "cvr-button min-h-0 min-w-0 !px-4 !py-2",
              className,
            )}
            style={style}
            {...(!showText && { "aria-label": "Min side" })}
          >
            {showIcon ? (
              orgId ? (
                <Building className="inline" width={28} height={28} />
              ) : (
                <User className="inline" width={28} height={28} />
              )
            ) : null}
            {showText ? <span className="text-base">Min side</span> : null}
          </button>
        </Link>
      </Show>
    </>
  );
}
